// extracted by mini-css-extract-plugin
export default {"breadcrumb":"ii-z","breadcrumbItem":"ji-z"};